import { apiSlice } from 'src/rtk/api/apiSlice';
import * as userUrl from 'src/helpers/url_helper';

interface Paginate {
  page: number | string;
  paginate_per_page?: number;
  search?: string;
}

export const authApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ['Users', 'Notification'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUsers: builder.query<APIResponse<User[]>, void>({
        query: () => ({
          method: 'GET',
          url: `${userUrl.GET_USERS}`,
        }),
        providesTags: ['Users'],
      }),

      getNotificationStatus: builder.query<APIResponse<any>, void>({
        query: () => ({
          method: 'GET',
          url: `${userUrl.NOTIFICATION_STATUS}`,
        }),
        providesTags: ['Notification'],
      }),

      getAllNotification: builder.query<APIResponseWithPagination<any>, string>({
        query: (url) => ({
          method: 'GET',
          url: `${userUrl.GET_ALL_NOTIFICATION}?${url}`,
        }),
        providesTags: ['Notification'],
      }),

      getNotificationSeen: builder.query<any, {registration_no: string}>({
        query: (obj) => ({
          method: 'GET',
          url: `${userUrl.GET_NOTIFICATION_SEEN}/${obj.registration_no}`,
        }),
        providesTags: ['Notification'],
      }),

      getUsersByPaginate: builder.query<
        APIResponseWithPagination<User>,
        Paginate
      >({
        query: (paginate) => {
          let url = `${userUrl.GET_USERS_BY_PAGINATE}?`;

          if (paginate.page) {
            url += `&page=${paginate.page}`;
          }
          if (paginate.paginate_per_page) {
            url += `&paginate_per_page=${paginate.paginate_per_page}`;
          }
          if (paginate.search) {
            url += `&search=${paginate.search}`;
          }

          return {
            method: 'GET',
            url: url,
          };
        },
        providesTags: ['Users'],
      }),

      getUser: builder.query<User, string>({
        query: (id) => ({
          url: `${userUrl.GET_USER}/${id}`,
          method: 'GET',
        }),
        providesTags: ['Users'],
      }),

      createUser: builder.mutation<APIResponse<User>, User>({
        query: (data) => ({
          url: `${userUrl.CREATE_USER}`,
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }),
        invalidatesTags: ['Users'],
      }),

      updateUser: builder.mutation<APIResponse<User>, any>({
        query: (url) => ({
          url: `${userUrl.UPDATE_USER}/${url}`,
          method: 'PUT',
        }),
        invalidatesTags: ['Users'],
      }),
      deleteUser: builder.mutation({
        query: (id: number) => ({
          method: 'DELETE',
          url: `${userUrl.DELETE_USER}/${id}`,
        }),
        invalidatesTags: ['Users'],
      }),
    }),
  });

export const {
  useCreateUserMutation,
  useGetUsersQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUsersByPaginateQuery,
  useGetNotificationStatusQuery,
  useGetAllNotificationQuery,
  useGetNotificationSeenQuery,
} = authApi;
